import { useContext } from "react";
import { DebtsContext } from "./DebtsProvider";

export const useDebtsContext = () => {
	const context = useContext(DebtsContext);

	return context;
};
